import GeoJSONLayer from '@arcgis/core/layers/GeoJSONLayer';
import SimpleRenderer from '@arcgis/core/renderers/SimpleRenderer';
import SimpleFillSymbol from '@arcgis/core/symbols/SimpleFillSymbol';
import React, { useEffect, useMemo } from 'react'
import { DECLARATIONS_MIN_SCALE_TO_SHOW } from '../../App/useNotificationsLayer';
import useBboxUpdate from '../../pages/ForestsNearUs/components/Map/useBboxUpdate';
import MapView from '@arcgis/core/views/MapView';
import { useTranslation } from 'react-i18next';
import useTestLayer from '../../App/useTestLayer';
import errors from '../../App/errors';

const openAreasLayerUrl = "https://avoin-paikkatieto.maanmittauslaitos.fi/maastotiedot/features/v1/collections/muuavoinalue/items";

export default function useOpenAreasLayer(view: MapView) {
    const { t, i18n } = useTranslation("common");

    const openAreasRenderer = new SimpleRenderer({
        symbol: new SimpleFillSymbol({
            color: "grey"
        })
    });

    const openAreasLayer = useMemo(() => new GeoJSONLayer({
        url: openAreasLayerUrl,
        visible: true,
        title: "Maastokartan avoimet alueet (l. aukot)",
        renderer: openAreasRenderer,
        minScale: DECLARATIONS_MIN_SCALE_TO_SHOW,
        customParameters: {
            "api-key": `${process.env.REACT_APP_MML_API_KEY}`
        },
    }), []);

    const useBboxUpdateForOpenAreas = useBboxUpdate(view, openAreasLayer, {
        "api-key": `${process.env.REACT_APP_MML_API_KEY}`
    });

    useTestLayer(openAreasLayerUrl + `?api-key=${process.env.REACT_APP_MML_API_KEY}`, { ...errors.layerLoadingFailed, replacementValues: ["avoimet alueet"] });

    useEffect(() => {
        if (openAreasLayer) {
            openAreasLayer.title = t("aukotKerrosOtsikko");
        }
    }, [i18n.language, t]);

    return (
        openAreasLayer
    )
}
